import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Subscription } from 'rxjs';

import { TBotItem } from '@core/interfaces/TBotItem';

import { BotsService } from '@shared/services/bots.service';

type TBotItemWithSelected = Pick<TBotItem, keyof TBotItem> & { selected?: boolean };

@Component({
  selector: 'app-agent-selector',
  templateUrl: './agent-selector.component.html',
  styleUrls: ['./agent-selector.component.scss'],
  standalone: true,
  imports: [CommonModule, MatTooltipModule],
})
export class AgentSelectorComponent implements OnInit, OnDestroy {
  @Input() selectedBotId: string | null = null;
  @Output() botSelected = new EventEmitter<TBotItem>();

  protected bots: TBotItemWithSelected[] = [];
  protected _subs: Subscription[] = [];

  constructor(
    private _botsService: BotsService,
    private _cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.getBots();
    this._botsService.fetchBots();
  }

  selectBot(id: string) {
    const selectedBot = this.bots.find(bot => bot._id === id);
    if (selectedBot) {
      this.botSelected.emit(selectedBot);
    }
  }

  getBots() {
    this._subs.push(
      this._botsService.getBotsObservable().subscribe(bots => {
        this.bots = [];
        bots
          .sort((a, b) => a.name.localeCompare(b.name))
          .forEach(bot => {
            // Only show bots that have "Show Button on Tile" enabled
            const shouldShow = bot.uiConfiguration?.homepage?.showButton === true;
            if (shouldShow) {
              this.bots.push(bot);
            }
          });

        this._cdr.detectChanges();
      })
    );
  }

  getTileName(bot: TBotItem): string {
    // Use buttonName if it exists, otherwise fall back to bot name
    return bot.uiConfiguration?.homepage?.buttonName || bot.name;
  }

  ngOnDestroy() {
    this._subs.forEach(sub => sub.unsubscribe());
  }
}
